import { useRouter } from '@tanstack/react-router';
import { ConnectorRouteView, JourneysConnectorHandoff, useConnectorHandoffHrefs } from '@/features/integrations';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import SegmentInPage from './index.page';

/** The two spellings of this connector's URL. */
function useHandoffHrefs() {
  const router = useRouter();

  return useConnectorHandoffHrefs({
    buildMigrated: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/integrations/segment_in', params: { workspaceId } }).href,
    buildLegacy: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/journeys/integrations/segment_in', params: { workspaceId } })
        .href,
  });
}

/**
 * The old `/journeys/integrations/segment_in` URL.
 *
 * Answers for the flag alone, as its Segment source sibling now does too. There is one
 * generation of this connector, so no record has to load before the URL knows
 * which app serves it.
 */
export function JourneysSegmentInHandoff() {
  const isMigrated = useFeatureFlag(AccountFeatureFlag.SegmentCdpIntegrationsMigration);
  const { migrated } = useHandoffHrefs();

  return <JourneysConnectorHandoff isMigrated={isMigrated} migratedHref={migrated} />;
}

/**
 * The migrated `/integrations/segment_in` URL.
 *
 * `ConnectorRouteView` applies the gates Ember's `integrations` root route applied.
 * This page's own route added no further gate: the three Segment permissions gate
 * individual controls, not access to the page, so a reader without them sees the
 * page with its actions disabled rather than a redirect.
 */
export function SegmentInRouteView() {
  const isMigrated = useFeatureFlag(AccountFeatureFlag.SegmentCdpIntegrationsMigration);
  const { legacy } = useHandoffHrefs();

  return (
    <ConnectorRouteView isMigrated={isMigrated} legacyHref={legacy}>
      {(workspaceId) => <SegmentInPage workspaceId={workspaceId} />}
    </ConnectorRouteView>
  );
}
